import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NgControl, ValidationErrors } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';

/**
 * Base class for date select components, contains main functionality for date select components to work
 */
@Directive({
  selector: 'dateSelectInput', // For some reason library doesnt work without adding this
})
export class DateSelectBase implements OnInit, ControlValueAccessor {
  control: AbstractControl | any;
  innerValue: NgbDate;
  _onChange = (val: NgbDate) => {};
  _onTouched = () => {};
  @Input() minDate: any;
  @Input() maxDate: any;
  @Input() placeholder: string = '--select--';
  @Input() readOnly: boolean = true;
  @Input() ariaLabel: string = 'Toggle date picker';
  @Output() dateChange: EventEmitter<{ date: NgbDate; isoString: string }>;

  constructor(private _ngControl: NgControl) {
    if (this._ngControl) {
      this._ngControl.valueAccessor = this;
    }
    this.dateChange = new EventEmitter();
  }

  ngOnInit(): void {
    if (this._ngControl) {
      this.control = this._ngControl.control;
      if (this.control && this.minDate && this.maxDate) {
        this.control.setValidators([this.validate.bind(this)]);
      }
      this.control.updateValueAndValidity();
    }
  }

  writeValue(value: NgbDate): void {
    this.innerValue = value;
    this._onChange(value);
    this.onDateChange(value);
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  onDateChange(date: NgbDate): void {
    this.dateChange.emit({ date, isoString: this._getStringFromNgbDate(date) });
  }

  /** Gets a date string in ISO format from an NgbDate. */
  private _getStringFromNgbDate(ngbDate: NgbDate) {
    if (ngbDate) {
      let date = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day, 12);
      date.setUTCHours(0);
      date.setUTCMinutes(0);
      date.setUTCSeconds(0);
      return date.toISOString();
    } else {
      return '';
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const date = DateTime.fromObject(this.innerValue, { zone: 'utc' });
    const minDate = DateTime.fromObject(this.minDate, { zone: 'utc' });
    const maxDate = DateTime.fromObject(this.maxDate, { zone: 'utc' });
    if (date < minDate || date > maxDate) {
      return { invalidDate: true };
    }
    return null;
  }
}
